<app-ci-multiselect
  variant="filled"
  [summary]="true"
  [label]="label"
  [required]="required"
  [items]="itemIds()"
  [displayWith]="displayName"
  [placeholder]="placeholder"
  [searchPlaceholder]="searchPlaceholder"
  [emptyLabel]="emptyLabel"
  [clearLabel]="clearLabel"
  [summaryTemplate]="summaryTemplate"
  [ngModel]="selectedIds"
  [ngModelOptions]="{standalone: true}"
  [invalid]="invalid"
  [errorText]="errorText"
  (selectionChange)="onPanelChange($event)"
></app-ci-multiselect>

@if (showSorting) {
  <div class="ci-ordered-list">
    <div class="ci-ordered-list__header">
      <span class="ci-ordered-list__header-title">{{ orderHeaderLabel }}</span>
      <span class="ci-ordered-list__header-hint">{{ orderHintLabel }}</span>
    </div>

    @if (rows().length === 0) {
      <div class="ci-ordered-list__empty">{{ emptyListLabel }}</div>
    } @else {
      <ol
        class="ci-ordered-list__rows"
        role="list"
        cdkDropList
        [attr.aria-label]="orderListAriaLabel || null"
        (cdkDropListDropped)="drop($event)"
      >
        @for (row of rows(); track row.id; let i = $index) {
          <li class="ci-ordered-list__row" cdkDrag>
            <button
              type="button"
              class="ci-ordered-list__drag"
              cdkDragHandle
              [attr.aria-label]="dragHandleAriaLabel || null"
            >
              <mat-icon>drag_indicator</mat-icon>
            </button>
            <span class="ci-ordered-list__position" aria-hidden="true">
              {{ row.position }}
            </span>
            <span class="ci-ordered-list__label">{{ row.name }}</span>
            <div class="ci-ordered-list__actions">
              <button
                type="button"
                class="ci-ordered-list__action"
                [disabled]="i === 0"
                [attr.aria-label]="moveUpAriaLabel(row.name, row.position, row.total)"
                (click)="moveUp(i)"
              >
                <mat-icon>arrow_upward</mat-icon>
              </button>
              <button
                type="button"
                class="ci-ordered-list__action"
                [disabled]="i === row.total - 1"
                [attr.aria-label]="moveDownAriaLabel(row.name, row.position, row.total)"
                (click)="moveDown(i)"
              >
                <mat-icon>arrow_downward</mat-icon>
              </button>
              <button
                type="button"
                class="ci-ordered-list__action ci-ordered-list__action--delete"
                [attr.aria-label]="deleteAriaLabel(row.name, row.position, row.total)"
                (click)="removeAt(i)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </li>
        }
      </ol>
    }
  </div>
}

@if (addButtonLabel) {
  <button
    type="button"
    class="ci-request-button"
    (click)="addClicked.emit()"
  >
    <mat-icon>add</mat-icon>
    <span>{{ addButtonLabel }}</span>
  </button>
}
